<script setup lang="ts">
const open = defineModel<boolean>({ default: false });
const { t } = useI18n();
const { subscribeToPush, isPushLoading } = usePushNotifications();
const api = useApi();
const toast = useToast();

const handleAccept = async () => {
  const success = await subscribeToPush();
  if (success) {
    toast.add({
      title: t('push.subscribed'),
      icon: 'i-heroicons-check-circle',
    });
  } else {
    toast.add({
      title: t('push.subscriptionFailed'),
      icon: 'i-heroicons-exclamation-circle',
      color: 'error',
    });
  }
  open.value = false;
};

const handleDecline = async () => {
  await api.post('/push/decline', {});
  open.value = false;
};

const handleCancel = () => {
  open.value = false;
};
</script>
<template>
  <UModal
    v-model:open="open"
    :ui="{
      overlay: 'z-[70]',
      content: 'z-[80]',
    }"
  >
    <template #header>
      <div class="flex items-center gap-3">
        <UIcon name="i-heroicons-bell" class="text-2xl text-primary" />
        <h2 class="text-xl font-bold">{{ $t('push.prompt.title') }}</h2>
      </div>
    </template>

    <template #body>
      <p class="mb-4">{{ $t('push.prompt.description') }}</p>
      <ul class="list-disc list-inside space-y-2 text-sm text-muted">
        <li>{{ $t('push.prompt.benefit1') }}</li>
        <li>{{ $t('push.prompt.benefit2') }}</li>
      </ul>
    </template>

    <template #footer>
      <div class="flex sm:justify-between w-full">
        <UButton variant="link" :label="$t('button.cancel')" @click="handleCancel" />
        <UButton variant="outline" color="neutral" :label="$t('push.prompt.decline')" @click="handleDecline" />
        <UButton variant="solid" :loading="isPushLoading" icon="i-heroicons-bell" :label="$t('push.prompt.accept')" @click="handleAccept" />
      </div>
    </template>
  </UModal>
</template>
